/**
 * REGISTRY DE OFERTAS EMBEBBED (ADMIN PREVIEW)
 * --------------------------------------------
 * Este diccionario mapea el `display_type` de una oferta con su componente de preview.
 *
 * A diferencia del Widget, los componentes aquí registrados son visuales:
 * - No modifican estados globales de carrito.
 * - Su único objetivo es mostrarle al merchant cómo se verá la oferta dentro del formulario.
 * - Están envueltos por la lógica de dnd (`SortableField`).
 *
 * Contrato: Todos los componentes registrados aquí deben cumplir con la interfaz `UpsellEmbedPreviewProps`.
 *
 */
import type React from "react";
import type { FormEmbeddableDisplayType } from "@codway-dev/shared";
import type { UpsellEmbedPreviewProps } from "./embeds/types";

import { OneTickEmbedPreview } from "./embeds/OneTickEmbedPreview";
import { QuantityTiersEmbedPreview } from "./embeds/QuantityTiersEmbedPreview";
import { BundleEmbedPreview } from "./embeds/BundleEmbedPreview";

export const UPSELL_EMBED_PREVIEW_REGISTRY: Record<
  FormEmbeddableDisplayType,
  React.FC<UpsellEmbedPreviewProps>
> = {
  one_tick: OneTickEmbedPreview,
  quantity_tiers: QuantityTiersEmbedPreview,
  bundle: BundleEmbedPreview,
};

export type { UpsellEmbedPreviewProps };
